import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit{

  public slideIndex=0;

  constructor(private router:Router) { }

  ngOnInit() {
    this.showSlidesAutomatic();
    //put the page name in the beard div of the navbar
    var beard = $(".beard");
    beard.text("Home");
  }

showSlidesAutomatic() { 
  var i;
  var slides = $(".mySlides"); 
  for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none"; 
  }

  if (this.slideIndex >= slides.length) {this.slideIndex = 0} 

  if(this.router.url === '/home'){
     slides[this.slideIndex].style.display = "block";
     this.slideIndex=this.slideIndex+1;
     var that = this;
     setTimeout(function(){
      that.showSlidesAutomatic()
     },3000);
  }

 }

}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts